import { createRouter, createWebHashHistory } from 'vue-router'
const layout = () => import('../layout/index.vue')
const routes = [
  {
    path: '/',
    name: 'oldHome',
    meta: {
      title: '服务云',
    },
    redirect: '/home/index',
  },
  {
    path: '/home',
    name: 'Home',
    meta: {
      title: '服务云',
    },
    component: layout,
    redirect: '/home/index',
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import('../views/index/index.vue'),
        meta: {
          title: '我的课程',
          keepAlive: true,
          saveSrollTop: true,
        },
      },
      // {
      //   path: 'test',
      //   name: 'test',
      //   component: () => import('../views/index/index.vue'),
      //   meta: {
      //     title: '我的课程',
      //     keepAlive: true,
      //     saveSrollTop: true,
      //   },
      // },
      {
        path: 'bindService',
        name: 'BindService',
        component: () => import('../views/index/bindServiceV2.vue'),
        meta: {
          title: '激活服务',
          keepAlive: true,
          saveSrollTop: true,
        },
      },
      {
        path: 'bindServiceV2',
        name: 'BindServiceV2',
        component: () => import('../views/index/bindServiceV2.vue'),
        meta: {
          title: '激活服务',
          keepAlive: true,
          saveSrollTop: true,
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/user/loginv2.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/passport',
    name: 'Passport',
    component: () => import('@/views/user/passport.vue'),
    meta: {
      hidden: true,
    },
  },
  // 课程服务模块
  {
    path: '/service',
    name: 'Service',
    component: () => import('../layout/index.vue'),
    meta: {
      title: '课程服务',
    },
    children: [
      {
        path: 'share',
        name: 'ServiceShare',
        component: () => import('../views/service/share.vue'),
        meta: {
          title: '课程分享',
          keepAlive: true,
          saveSrollTop: true,
          isBack: false,
        },
      },
      // 服务 新增  解锁课程服务内容-------------------------------------
      {
        path: 'content/:id',
        name: 'ServiceContent',
        component: () => import('../views/service/content.vue'),
        meta: {
          title: '课程内容',
          keepAlive: true,
          saveSrollTop: true,
          isBack: false,
        },
      },
      // 服务 新增  未解锁课程详情------------------------------------
      {
        path: 'wjsContent/:id',
        name: 'CaseWjsContent',
        component: () => import('../views/service/wjsContent.vue'),
        meta: {
          title: '产品介绍',
          keepAlive: true,
          saveSrollTop: true,
        },
      },

      // ------------------------------------------------------------end
      // {
      //   path: 'userSetting',
      //   name: 'UserSetting',
      //   component: () => import('../views/user/userSetting.vue'),
      //   meta: {
      //     title: '用户设置',
      //   },
      // },
      // //生成图片
      // {
      //   path: 'toImg/:id',
      //   name: 'CaseToImg',
      //   component: () => import('../views/service/caseToImg.vue'),
      //   meta: {
      //     title: '生成图片',
      //     hideCopyRight: true,
      //   },
      // },
    ],
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('../views/index/components/agreement.vue'),
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue'),
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/404',
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.saveSrollTop) {
        from.meta.savedPosition =
          document.documentElement.scrollTop || document.body.scrollTop
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  },
  routes,
})

export default router
